
export default function br() {
  return (
    <svg
      width="30"
      height="30"
      x="0"
      y="0"
      version="1.1"
      viewBox="-566.727 -103 161.439 210.377"
      xmlSpace="preserve"
    >
      <g strokeWidth="2.684" transform="translate(-32.177 -284.403)">
        <path
          stroke="#000"
          strokeLinecap="square"
          d="M-379.394 368.923h-3.05v-18.318l-14.677-16.437h-.15v-96.962h.15l19.097-18.267h.122v-31.25c0-2.732-2.12-4.944-4.73-4.944h-26.421v16.986l-14.829 4.912-13.664-4.912v-16.986h-32.566v16.986l-13.667 4.912-14.827-4.912v-16.986h-26.416c-2.612 0-4.728 2.212-4.728 4.944v31.25h.053l19.166 18.267v96.962l-14.68 16.437v18.318h-3.052a4.947 4.947 0 00-4.945 4.95v11.622a4.945 4.945 0 004.945 4.943H-379.4a4.945 4.945 0 004.947-4.943v-11.623c0-2.705-2.215-4.94-4.949-4.94z"
        ></path>
        <path
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          d="M-520.373 368.923L-388.367 368.923"
        ></path>
        <path
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          d="M-519.792 350.613L-388.946 350.613"
        ></path>
        <path
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          d="M-402.902 334.19L-506.996 334.19"
        ></path>
        <path
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          d="M-506.417 237.227L-402.32 237.227"
        ></path>
        <path
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          d="M-523.281 218.949L-381.971 218.949"
        ></path>
      </g>
    </svg>
  );
}
